import {MinTrackerRes, TrackerCreateReq, TrackerDetailRes} from "./tracker.contract";
import {TodoDetailRes} from "../todo.contract";
import {UserDetailsRes} from '../../cp';
import {Type} from 'class-transformer';

export class TodoTrackerDetailRes extends TrackerDetailRes {
    @Type(() => TodoDetailRes)
    toDo!: TodoDetailRes;
    @Type(() => UserDetailsRes)
    user!: UserDetailsRes;
}

export class MinToDoTrackerRes extends MinTrackerRes {
    @Type(() => TrackerDetailRes)
    toDo!: TrackerDetailRes;
    @Type(() => UserDetailsRes)
    user!: UserDetailsRes;
}

export class ToDoTrackerCreateReq extends TrackerCreateReq {
    toDoId!: number;
    groupId!: number;
}
